
import { useMemo } from 'react';
import { Task } from '@/types/tasks';

/**
 * Hook to calculate task counts
 */
export const useTaskCount = (activeTasks: Task[]) => {
  const activeTaskCount = useMemo(() => {
    return activeTasks.length;
  }, [activeTasks]);

  return {
    activeTaskCount
  };
};
